import { apiVersions, getLogicEndpoint } from './endpoints';
import { appFetch } from './appClient';

/** Thumbs up/down sentiment (case-sensitive, per the feedback API). */
export type FeedbackSentiment = 'ThumbsUp' | 'ThumbsDown';

export interface AssistantFeedbackPayload {
  sentiment: FeedbackSentiment;
  /** Optional free-text comment. */
  comment?: string;
  /** Current workflow. */
  workflow?: unknown;
  /** Chat history sent for context. */
  chatHistory?: { role: string; content: string }[];
}

/**
 * Records thumbs up/down feedback for an assistant interaction. Fire-and-forget
 * (the endpoint returns 202 Accepted with an empty body).
 */
export const submitAssistantFeedback = async (opts: {
  projectName: string;
  workflowName: string;
  getToken: () => Promise<string | null>;
  feedback: AssistantFeedbackPayload;
}): Promise<void> => {
  const accessToken = await opts.getToken();
  if (!accessToken) {
    throw new Error('Failed to get access token for assistant feedback');
  }

  const url = `${getLogicEndpoint()}/automationProjects/${encodeURIComponent(opts.projectName)}/workflows/${encodeURIComponent(opts.workflowName)}/workflowAssistants/default/feedback?api-version=${apiVersions.otto}`;
  await appFetch<void>(url, accessToken, {
    method: 'POST',
    body: JSON.stringify(opts.feedback),
  });
};
